import { Modal, Spin } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { Server } from '@wajeez-web/core/api-base';
import { WajeezMultilingualFormBuilder } from '@wajeez-web/components/form-builder';
import { useCreateBadge } from '@wajeez-web/components/helpers';
import { Languages } from '@wajeez-web/core/utils';
import { CreateBadgeInput } from '@wajeez-web/stores/content';

const BadgeModal = ({
  isOpen,
  onClose,
  onSubmit,
}: CommonModalProps<CreateBadgeInput>) => {
  const { status: createBadgeStatus } = useCreateBadge();

  return (
    <Modal
      title="Badge"
      withScroll={true}
      open={isOpen}
      onClose={onClose}
      fontClassName="font-[Tajawal]"
      overflowClassName="overflow-y-hidden"
      alertTarget="modal"
    >
      <div className="w-full pb-16">
        {onSubmit && (
          <WajeezMultilingualFormBuilder<CreateBadgeInput>
            isUpdate={createBadgeStatus === 'loading'}
            hasToggleButton={true}
            onSubmit={onSubmit}
            formValues={{ profiles: [{ languageId: Languages.AR }] }}
            rows={{
              referenceName: {
                order: 400,
                label: 'Reference Name',
                placeHolder: 'Reference Name',
                required: false,
                fieldType: Server.FieldType.Text,
                fieldOptions: {},
              },
            }}
            profileRows={{
              title: {
                order: 100,
                label: 'Title',
                placeHolder: 'Title',
                required: true,
                fieldType: Server.FieldType.Text,
                fieldOptions: {},
              },
              description: {
                order: 200,
                label: 'Description',
                placeHolder: 'Description',
                required: true,
                fieldType: Server.FieldType.AreaText,
                fieldOptions: {},
              },
              imageReference: {
                order: 300,
                label: 'Image Reference',
                placeHolder: 'Image Reference',
                required: false,
                fieldType: Server.FieldType.UploadImage,
                fieldOptions: {},
              },
            }}
          />
        )}
      </div>
    </Modal>
  );
};

export default BadgeModal;
